import {isReleasedNewRegisterFlow} from '../../../config/unReleasePage';
import type {UserType} from './AuthContext';

/**
 * 大学認証が完了しているか
 * 新登録フロー未リリース時、または大学認証情報が取得できていない場合(未ログイン等)は
 * 認証済みとみなして機能を制限しない
 */
export const isStudentVerified = (user: UserType | undefined): boolean =>
  isReleasedNewRegisterFlow() ? user?.isStudentVerified !== false : true;
